export const TableType = {
    // BIT_* are the actual values,
    // Below are so called 'alias' or simple combinations
    // of the bit values into 'combo' type
    DINE_IN  : 1,
    PICKUP   : 2,
    DELIVERY : 4,
    LANDING  : 8,
    PICKUP_OR_DELIVERY          : 6,    // 2 + 4 = 6
    DINE_IN_WITH_PAYMENT        : 18,   // 2 + 16 = 18
    DINE_IN_MERCHANT_PRIVATE    : 33,   // 1 + 32 = 33
    DINE_IN_HIDE_FROM_LANDING   : 65,   // 1 + 64 = 65

    BIT_DINEIN      : 1,            // 0001
    BIT_PICKUP      : 1 << 1,       // 0010
    BIT_DELIVERY    : 1 << 2,       // 0100
    BIT_LANDING     : 1 << 3,       // 1000, You get the idea...
    BIT_DINE_IN_WITH_PAYMENT    : 1 << 4,       // 1000, You get the idea...
    BIT_MERCHANT_PRIVATE        : 1 << 5,
    BIT_HIDE_FROM_LANDING       : 1 << 6,
}